import script from "./xtx-steps.vue?vue&type=script&lang=jsx"
export * from "./xtx-steps.vue?vue&type=script&lang=jsx"

import "./xtx-steps.vue?vue&type=style&index=0&id=681fa49d&lang=less"

const __exports__ = script;

export default __exports__